import { render } from "./popupBase.vue?vue&type=template&id=796d9c2e&scoped=true"
import script from "./popupBase.vue?vue&type=script&lang=js"
export * from "./popupBase.vue?vue&type=script&lang=js"

import "./popupBase.vue?vue&type=style&index=0&id=796d9c2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-796d9c2e"]])

export default __exports__